/* eslint-disable react/prop-types */
import styled from '@emotion/styled';
import Icon from 'components/icon';
import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const CustomModal = styled(Modal)`
  background-color: #0000004b;
  backdrop-filter: blur(2px);
  & .modal-dialog {
    margin-right: auto;
    margin-left: auto;
  }
  & .modal-header .btn-close {
    background-color: #ffffff39;
  }
`;

function ConfirmationModal({
  show,
  handleClose,
  handleConfirm,
  icon,
  severity,
  message = 'Are you sure you want to disable? This action cannot be undone.',
  confirmBtn,
  showFooter = true
}) {
  return (
    <CustomModal
      show={show}
      onHide={handleClose}
      backdrop="static"
      // contentClassName={`bg-soft-${severity}`}
      centered
    >
      <Modal.Header className="border-0 d-flex justify-content-center">
        <Modal.Title>
          <Icon
            icon={icon || 'streamline:warning-triangle-solid'}
            className={`text-${severity || 'warning'}`}
            fontSize="48px"
          />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={`text-${severity} text-center`} role="alert">
          {typeof message === 'function' ? message(handleClose) : message}
        </div>
      </Modal.Body>
      {showFooter ? (
        <Modal.Footer className="border-0 d-flex justify-content-center">
          <Button variant="outline-secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant={severity} onClick={handleConfirm}>
            {confirmBtn || 'Disable'}
          </Button>
        </Modal.Footer>
      ) : null}
    </CustomModal>
  );
}

export default ConfirmationModal;
